import React from 'react';
import './styles/AppLogo.css';
export const AppLogo = () => <span className="appLogo" />;
